function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegionalManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/regional-manager",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1243",
    d: "M17567.223 15669a2.2 2.2 0 0 1-2.221-2.18 6.432 6.432 0 0 1 1.023-3.486 6.679 6.679 0 0 1 2.66-2.371l2.25 4.248v.006a.824.824 0 0 0 1.453 0v-.006l2.246-4.248a6.677 6.677 0 0 1 2.664 2.371 6.432 6.432 0 0 1 1.023 3.486 2.205 2.205 0 0 1-2.223 2.18zm3.891-5.371-.008-.006-2.633-4.973a3.925 3.925 0 0 1 .047-3.771 3.593 3.593 0 0 1 3.066-1.875 1.123 1.123 0 0 1 .162 0 3.587 3.587 0 0 1 3.063 1.875 3.925 3.925 0 0 1 .051 3.771l-2.637 4.973v.006a.629.629 0 0 1-1.109 0zm-.939-7.2a1.494 1.494 0 1 0 1.494-1.539 1.518 1.518 0 0 0-1.495 1.534z",
    transform: "translate(-17559.668 -15648.998)",
    style: {
      fill: "#808285"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegionalManager);
export default __webpack_public_path__ + "static/media/icon_regional-manager.7704c946.svg";
export { ForwardRef as ReactComponent };